export const USER_LOGIN = `mutation login($email:String! $password:String!) {
    login(username:$email password:$password) {
      token
    }
  }`;
